<template>
  <div class="card is-full-width-height">
    <gmap-map
      :center="centerDefault"
      :zoom="zoomDefault"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      class="googleMap"
      @tilesloaded="actionMapIsLoaded"
      @zoom_changed="getZoom = $event"
      ref="mapCartoGeneral">
      <div v-if="isMapLoaded">
        <gmap-marker
        v-if="getPdv"
        :position="getPdv.adresse.coordonnees"
        :icon="getIconPdv(getPdv.icon)">
      </gmap-marker>

    
        <!-- Marker panneau -->
        <gmap-marker
          v-for="(markerPanneau, index) in markersPanneaux"
          :key="index + 'panneau'"
          :position="markerPanneau.adresse.coordonnees"
          :icon="markerPanneau.iconMarker"
          @click="affichePanneau(index)">
        </gmap-marker>

      <!-- Liste des concurrents -->

        <gmap-marker
          v-for="(marker, index) in listeMarkerPdvConcurrents.length
           ? listeMarkerPdvConcurrents : []"
          :key="`con${index}`"
          :position="marker.data.coordonnees"
          :icon="marker.iconMarker">
        </gmap-marker>

      </div>
      <!-- Marker point de vente -->
      
    </gmap-map>
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <detailPanneau :bg="bg" :detailPanneau="detailPanneau" :enseigne="this.getPdv.enseigne" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CENTER_DEFAULT, ZOOM_DEFAULT,
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import {
  iconMarkerInfoBulle,
  getIconPdvData,
  iconPointDeVente,
} from '@/services/gestionIconMarker/iconColorGetter';
import DetailPanneau from '@/components/portail/blocProduits/DetailPanneau';
import gestionErreur from '@/services/general/gestionErreur';
import siteConfig from '@/configurations/siteConfig';

const User = createNamespacedHelpers('user');
const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: { DetailPanneau },
  data() {
    return {
      isLoadOnce: false,
      centerDefault: CENTER_DEFAULT,
      zoomDefault: ZOOM_DEFAULT,
      getZoom: 0,
      isLoading: false,
      isMapLoaded: false,
      markersPanneaux:[],
      show: false,
      bg: false,
      detailPanneau:  {},
      listeMarkerPdvConcurrents: [],
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  watch: {
    getPdvConcurrentsSelected: {
      async handler() {
        await this.genererListePdvConcurrentAvecMarker();
        this.fitBounds();
      },
    },
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Recommandation.mapGetters({
      getPdv: 'pdv',
      getPanneaux: 'panneaux',
      getPdvConcurrentsSelected: 'pdvConcurrentSelected',
    }),
  },
  mounted () {
   this.genererListePanneauMarker();
   this.genererListePdvConcurrentAvecMarker();
  },
  methods: {
    getIconPdv(url) {
      const { widthIcon, getGoogleAnchor } = (siteConfig[this.site] || siteConfig.default).pdv;
      let srcUrl = require('@/assets/images/icon_marker/marker_default_pdv.png');
      let height = 45;
      let width = 38;
      if (url.includes('data:image')) {
        srcUrl = url;
        width = widthIcon - 5;
        height = widthIcon;
      }
      return {
        url: srcUrl,
        scaledSize: new google.maps.Size(width, height),
        origin: new google.maps.Point(0, 0),
        anchor: getGoogleAnchor(height, width),
      };
    },
    async getIconPanneau(panneau, index) {
      if (panneau.ancienPanneau === "OUI") {
        return await iconMarkerInfoBulle('#4d4d4d', panneau.azimut,  index);
      }
      return await iconMarkerInfoBulle(panneau.categorie.couleur, panneau.azimut, index);
    },
    async levelZoom() {
      await this.$refs.mapCartoGeneral.$mapPromise;
      await this.fitBounds();
    },
    getIconPdvTiers(url) {
      return new Promise(resolve => {
        const img = document.createElement('img');
        img.onload = () => {
          const logo = iconPointDeVente(img);
          const icon = {
            url: logo,
            scaledSize: new google.maps.Size(28, 33),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(28 / 2, 33),
          };
          resolve(icon);
        };
        img.onerror = () => {
          img.src = require('@/assets/images/default_img.png');
        };
        img.setAttribute('src', url);
        img.setAttribute('crossOrigin', 'Anonymous');
      });
    },
    async genererListePanneauMarker() {
      const liste = cloneDeep(this.getPanneaux.filter(p => !['FORFAIT HONORAIRES', 'honoraire'].includes(p.categorie.libelle)));
      const req = liste.map(el => this.getIconPanneau(el, el.num));
      const res = await Promise.all(req);
      liste.forEach((el, i) => {
        el.iconMarker = res[i];
      });
      this.markersPanneaux = liste;
    },
    async genererListePdvConcurrentAvecMarker() {
      const { widthIcon, heightIcon } = (siteConfig[this.site] || siteConfig.default).pdvConcurent;
      const liste = cloneDeep(this.getPdvConcurrentsSelected);
      const req = [];
      liste.forEach(el => {
        req.push(getIconPdvData(el.data.urlLogo, widthIcon, heightIcon, ''));
      });
      const res = await Promise.all(req);
      liste.forEach((el, i) => {
        el.iconMarker = res[i].icon;
      });
      this.listeMarkerPdvConcurrents = liste;
    },
    affichePanneau(i) {
      this.detailPanneau = this.getPanneaux[i];
      this.show = true;
    },
    async fitBounds() {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(this.getPdv.adresse.coordonnees);
      if (this.markersPanneaux.length) {
        this.markersPanneaux.forEach(el => {
          bounds.extend(el.adresse.coordonnees);
        })
      }
      if (this.listeMarkerPdvConcurrents.length) {
        this.listeMarkerPdvConcurrents.forEach(el => {
          bounds.extend(el.data.coordonnees);
        });
      }

      this.$refs.mapCartoGeneral.fitBounds(bounds);
      const map = await this.$refs.mapCartoGeneral.$mapPromise;
      map.setZoom(this.getZoom - 1);
      return '';
    },
    async actionMapIsLoaded() {
      if (!this.isMapLoaded) {
        const styleMap = new google.maps.StyledMapType(
          STYLE_MAPS_POI_HIDDEN,
          { name: MAP_TYPE_NAME },
        );
        this.$refs.mapCartoGeneral.$mapPromise.then((map) => {
          map.mapTypes.set("styled_map", styleMap);
        });
        await this.levelZoom();
        this.isMapLoaded = true;
      }
    },
    async initCarto() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        if (this.$refs.mapCartoGeneral !== undefined) {
          const map = await this.$refs.mapCartoGeneral.$mapPromise;
          const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
            name: MAP_TYPE_NAME,
          });
          map.mapTypes.set('styled_map', styleMap);
        }
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
        gestionErreur('Erreur initialisation map');
      }
    }
  },
};
</script>
